import React, { useState, useEffect, useRef } from "react";
import { jwtDecode } from 'jwt-decode';
import MessageSection from "./Components/MessageSection";
import DashboardNavbar from "../Navbar/navbar-dashboard";
import ModernNavbarPureCSS from "../../components/Navbar/ModernNavBarPureCSS";


const Index = () =>
{
    const [notification, setNotification] = useState(true);
    const [username, setUsername] = useState('');

    useEffect(() => {

        const token = localStorage.getItem('token');

        if (token) {
        const decodeToken = jwtDecode(token);

        console.log("Decoded Token:", decodeToken);
        setUsername(decodeToken.UserName || 'User');

        }
    }, []);

    return (
        <>
            <ModernNavbarPureCSS UserName={username} prefix={''} TabActiveId={'messages'} />
            {/*
            <section class="inner-page-banner">
                <div class="container">
                    <div class="row">
                        <h1 class="banner-heading">MESSAGE</h1>
                    </div>
                </div>
            </section>
            */}
            <MessageSection setNotification={setNotification} notification={notification} />
        </>
    );
};

export default Index;
